/**
 * FikoKayitlar Dialog — Kayıtlı üretim belgeleri (teklif/iş emri/muayene/üretim kartı)
 * Tipe göre listele (DB+local), Yükle (modülü ön-dolu aç), Sil.
 */
import { Component, Input, ChangeDetectionStrategy, ChangeDetectorRef, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { KalicilikService, KayitTip, IKayit } from './kalicilik.service';

const TIPLER: { tip: KayitTip; ad: string; metod: string }[] = [
  { tip: 'teklif', ad: 'Teklif', metod: 'acTeklifDialog' },
  { tip: 'is_emri', ad: 'İş Emri', metod: 'acIsEmriDialog' },
  { tip: 'muayene', ad: 'Muayene', metod: 'acMuayeneDialog' },
  { tip: 'uretim_karti', ad: 'Üretim Kartı', metod: 'acUretimKartiDialog' },
];

@Component({
  selector: 'fikoyt-kayitlar',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule],
  template: `
  <div class="ky">
    <div class="ky-tab">
      @for (t of tipler; track t.tip) {
        <button class="ky-tb" [class.aktif]="aktifTip===t.tip" (click)="tipSec(t.tip)">{{ t.ad }}</button>
      }
    </div>
    @if (yukleniyor) { <div class="ky-bilgi">Yükleniyor…</div> }
    @else if (!liste.length) { <div class="ky-bilgi">Bu tipte kayıt yok.</div> }
    @else {
      <div class="ky-liste">
        @for (k of liste; track k.id) {
          <div class="ky-sat">
            <div class="ky-info">
              <div class="ky-baslik">{{ k.baslik }}</div>
              <div class="ky-meta">{{ tarih(k.tarih) }} <span class="ky-sync" [class.ok]="k._sync">{{ k._sync ? '☁ DB' : '◷ yerel' }}</span></div>
            </div>
            <button class="ky-yukle" (click)="yukle(k)">Yükle</button>
            <button class="ky-sil" (click)="sil(k)">✕</button>
          </div>
        }
      </div>
    }
  </div>
  `,
  styles: [`
    .ky { padding:10px; min-width:320px; max-width:380px; font-size:11px; color:#e6f6ff;
      background:linear-gradient(180deg,rgba(0,40,60,.96),rgba(0,18,36,.98)); border-radius:6px; }
    .ky-tab { display:flex; gap:4px; margin-bottom:8px; }
    .ky-tb { flex:1; padding:5px 4px; background:rgba(0,60,80,.6); border:1px solid rgba(0,200,220,.3); color:#bff; border-radius:5px; cursor:pointer; font-size:10px; }
    .ky-tb.aktif { background:linear-gradient(90deg,#0a84c0,#0bb39e); color:#fff; border:none; font-weight:600; }
    .ky-bilgi { padding:14px; text-align:center; color:#9fe8f7; opacity:.8; }
    .ky-liste { max-height:300px; overflow:auto; display:flex; flex-direction:column; gap:4px; }
    .ky-sat { display:flex; align-items:center; gap:6px; padding:6px 8px; background:rgba(0,0,0,.3); border:1px solid rgba(0,200,220,.15); border-radius:5px; }
    .ky-info { flex:1; min-width:0; }
    .ky-baslik { font-weight:600; color:#fff; white-space:nowrap; overflow:hidden; text-overflow:ellipsis; }
    .ky-meta { font-size:9px; color:#9fe8f7; }
    .ky-sync { margin-left:6px; color:#ffb36a; } .ky-sync.ok { color:#7dffc0; }
    .ky-yukle { background:rgba(0,120,90,.6); border:1px solid rgba(0,255,150,.35); color:#bfffe0; border-radius:4px; padding:5px 9px; cursor:pointer; font-size:10px; white-space:nowrap; }
    .ky-yukle:hover { background:rgba(0,160,110,.8); }
    .ky-sil { background:rgba(120,40,40,.6); border:1px solid rgba(255,100,100,.4); color:#ff9a9a; border-radius:4px; cursor:pointer; padding:5px 8px; }
  `]
})
export class FikoKayitlarComponent {
  @Input() pencere: any;
  @Input() ayarlar: any = {};
  @Input() ana: any = null;
  private _p: any = {};
  @Input() set baslangicTip(v: KayitTip) { if (v) { this.aktifTip = v; } }

  private kalicilik = inject(KalicilikService);
  tipler = TIPLER;
  aktifTip: KayitTip = 'teklif';
  liste: IKayit[] = [];
  yukleniyor = false;

  constructor(private cd: ChangeDetectorRef) { setTimeout(() => this.tipSec(this.aktifTip), 0); }

  async tipSec(tip: KayitTip): Promise<void> {
    this.aktifTip = tip; this.yukleniyor = true; this.liste = []; this.cd.detectChanges();
    try { this.liste = await this.kalicilik.listele(tip); } catch { }
    this.yukleniyor = false; this.cd.detectChanges();
  }

  yukle(k: IKayit): void {
    this.kalicilik.yuklemeyeAl(this.aktifTip, k.veri);
    const metod = this.tipler.find(t => t.tip === this.aktifTip)?.metod;
    try { if (metod) this.ana?.[metod]?.(); } catch { }
    try { this.pencere?.instance?.kapa?.(); } catch { }
  }

  async sil(k: IKayit): Promise<void> {
    await this.kalicilik.sil(this.aktifTip, k);
    this.liste = this.liste.filter(x => x.id !== k.id);
    this.cd.detectChanges();
  }

  tarih(iso: string): string { try { return new Date(iso).toLocaleString('tr-TR', { day: '2-digit', month: '2-digit', year: '2-digit', hour: '2-digit', minute: '2-digit' }); } catch { return iso; } }
}
